export default __webpack_public_path__ + "static/media/snowcrave.eeaae904.jpeg";